import {JsonPatchOperation} from "common/services/api/attorney-hub-api-service";
import Guid from "common/values/guid/guid";
import _ from "lodash";
import CompanyProfile from "marketplace/values/company-profile/company-profile";

export default class UpdateMarketplaceCompanyAPIRequest {
  payload: JsonPatchOperation[] = []

  constructor(
    isVisible: boolean,
    contactId?: Guid,
    originalProfile?: CompanyProfile,
    updatedProfile?: CompanyProfile
  ) {
    this.payload.push({
      op: "replace",
      path: "/isVisible",
      value: isVisible
    });
    if (contactId) {
      this.payload.push({
        op: "replace",
        path: "/contactId",
        value: contactId?.toString()
      });
    }

    if (originalProfile && updatedProfile) {
      if (!updatedProfile.name) throw new Error("Company name is required");
      this.addProfilePatch("name", updatedProfile.name, originalProfile.name);
      this.addProfilePatch("yearEstablished", updatedProfile.yearEstablished, originalProfile.yearEstablished);
      this.addProfilePatch("numberOfEmployees", updatedProfile.numberOfEmployees, originalProfile.numberOfEmployees);
      this.addProfilePatch("description", updatedProfile.description, originalProfile.description);
      this.addProfilePatch("location", updatedProfile.location, originalProfile.location);
      if (updatedProfile.website?.toString() !== originalProfile.website?.toString()) {
        this.payload.push({
          op: "replace",
          path: "/website",
          value: updatedProfile.website?.toString()
        });
      }
      if (!_.isEqual(updatedProfile.categories, originalProfile.categories)) {
        this.payload.push({
          op: "replace",
          path: "/categories",
          value: updatedProfile.categories
        });
      }
    }
  }

  private addProfilePatch(field: string, updatedValue: unknown, originalValue: unknown) {
    if (updatedValue !== originalValue) {
      this.payload.push({
        op: "replace",
        path: `/${field}`,
        value: updatedValue
      });
    }
  }
}
